module.exports = require("./bez.d.ts");